jQuery(function () {
    $('.campaign-base__read-more-btn').on('click', function () {
        var readMoreBtn = $(this);
        var btnText = readMoreBtn.text().trim();
        var currentCampaign = readMoreBtn.closest('.campaign-base');
        var currentCampaignInfo = currentCampaign.next('.campaign-base__read-more-info');
        readMoreBtn.toggleClass('expanded');
        readMoreBtn.text(btnText === 'Läs mer' ? 'Dölj' : 'Läs mer');
        currentCampaignInfo.slideToggle();
        currentCampaignInfo.toggleClass('expanded');
    });
    $('.ts-interest-collection-toggle-btn').on('click', function () {
        $(this).parent().find('.interest-collection__read-more-info__content-info').slideToggle();
    });
    $('.ts-interest-collection-close-btn').on('click', function () {
        $(this).closest('.interest-collection__read-more-info__content-info').slideToggle();
    });
});
